export const GenderEnum = Object.freeze({ girl: 0, boy: 1, either: -1 })

export type GenderKey = keyof typeof GenderEnum
export type GenderValue = typeof GenderEnum[GenderKey]

export const GenderProps: Record<GenderKey, { class: string, title: string }> = {
  girl: { class: 'bm_icon_baby', title: 'Baby girl' },
  boy: { class: 'bm_icon_baby-1', title: 'Baby boy' },
  either: { class: 'bm_icon_pacifier', title: 'Either' },
}
